import { MOBILE_BREAKPOINT } from "@kaggle/core";

export const isMobile = () => {
  return document.body?.clientWidth <= MOBILE_BREAKPOINT;
};
